import React from 'react'
import adminStyles from '../styles/Admin.module.css'
import Router from 'next/router'
import useAuth from '../hooks/auth'

function Logout() {
	const auth = useAuth()

	// remove cookie named aggie from the browser
	document.cookie = 'aggie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'

	auth.logout()

	fetch('/api/accountActions', {method:'GET'}).then(() => {
		Router.push('/')
	})

	return (
		<div className={adminStyles.main}>
			<h1>Logging... Out</h1>
		</div>
	)
}

export default Logout
